import { createSlice } from '@reduxjs/toolkit'

const coachingSlice = createSlice({
  name: 'coaching',
  initialState: { isOpen: false },
  reducers: {
    openCoaching: (state) => {
      state.isOpen = true
    },
    closeCoaching: (state) => {
      state.isOpen = false
    },
  },
})

export const { openCoaching, closeCoaching } = coachingSlice.actions
export const selectIsCoachingOpen = (state) => state.coaching.isOpen
export default coachingSlice.reducer
